import { queryAll, query, fromId } from '../utils/utils.js';
import { LocationSearch } from './location-search.js';
import { SiteSearch } from './site-search.js';
import { HeaderSearch } from './header-search.js';
import { NewsSearch } from './news-search.js';
import { ProviderSearch } from './provider-search.js';
import { ServiceSearch } from './service-search.js';

export class Search {

	constructor() {

		if (query('body.search-results') !== null || query('body.search-no-results') !== null){
			const siteSearch = new SiteSearch();
			siteSearch.init();
		}
		if (query('body.page-template-single-find-a-location') !== null){
			const locationSearch = new LocationSearch();
			locationSearch.init();
		}
		if (query('body.page-template-single-news-and-events') !== null){
			const newsSearch = new NewsSearch();
			newsSearch.init();
		}

		if (query('body.page-template-single-find-a-provider') !== null){
			const providerSearch = new ProviderSearch();
			providerSearch.init();
		}

		if (query('body.page-template-single-find-service') !== null){
			const serviceSearch = new ServiceSearch();
			serviceSearch.init();
		}

		// Header autocomplete starts only when the search panel is used.
		const headerSearch = new HeaderSearch();
		headerSearch.init();
		this.initHeaderSearch();
	}

	initHeaderSearch() {

	}
}
